export default "__VITE_ASSET__DN_nENf0__"